// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"8058099f","254":"43ddf386"}[chunkId] + ".chunk.js";
};